import { FormattedMessage, useIntl, defineMessages } from 'react-intl'
import { FormInput } from '../forms/final-form-fields'
import ActivityCheckbox from '../dive-center/ActivityFilters/ActivityCheckbox'
import { createUrl } from '../../localized-urls'
import { useState } from 'react'
import { isStaff } from '../../utils'

const messages = defineMessages({
  nameOnCard: {
    id: 'name_on_card',
    defaultMessage: 'Card owner name',
    tagName: 'span',
  },
})

export default function Cards({ errorsRef, isLoading, buttonText, isAdventure }) {
  const [checked, setChecked] = useState(isAdventure)
  const intl = useIntl()
  return (
    <div className='payment-methods-list__inner'>
      <div id='cardForm'>
        <div className='payment-block text-left clearfix'>
          <p className='title'>
            <FormattedMessage id='card_details' defaultMessage='Card details' />
          </p>
          <div className='form-group'>
            <FormInput
              name='nameOnCard'
              isRequired
              label={intl.formatMessage(messages.nameOnCard)}
            />
          </div>
          <div className='form-group new-section'>
            <label>
              <FormattedMessage id='card' defaultMessage='Card' />{' '}
              <span className='asterisk'>*</span>
            </label>
            <div id='card-number' className='card-number-fake-input' />
          </div>
          <div className='error-msg stripe-errors' ref={errorsRef} />
          <div className='form-group card-info'>
            <div className='img-wrap'>
              <img src='/images/secured.png' />
              <FormattedMessage
                id='all_transactions'
                tagName='p'
                defaultMessage='All transactions are secured and encrypted.'
              />
            </div>
          </div>
          <div className='form-group'>
            {!isAdventure && (
              <ActivityCheckbox
                isChecked={checked}
                changeHandler={setChecked}
                title={
                  isStaff()
                    ? (<FormattedMessage
                      values={{ a: (str) => <a href={createUrl('terms')} target='_blank'>{str}</a> }}
                      defaultMessage='By ticking this box, I confirm that I have read the <a>Terms and Conditions</a> of this sale and recorded agreement to these conditions from the authorised card holder' />)
                    : (<FormattedMessage
                      values={{ a: (str) => <a href={createUrl('terms')} target='_blank'>{str}</a> }}
                      defaultMessage='By ticking this box, I confirm that I am authorised to used this credit card and that I have read and agree to the <a>Terms and Conditions</a> of this sale' />)
                }
              />)}
          </div>
        </div>
      </div>
      <div className='payment-submit'>
        <button disabled={isLoading || !checked} className='btn-red' type='submit'>
          {buttonText || (
            <FormattedMessage id='save_cc' defaultMessage='Save credit card' />
          )}
        </button>
        <div className='payment-hint'>
          <FormattedMessage
            id='your-security-important'
            defaultMessage='Your security is important to us. We do not store your credit card information. All details are passed via a secure socket layer to a payment processor where your information is tokenized (i.e. anonimized). The payment processor is PCI compliant which ensures that your information is being handled in accordance with industry security standards.'
          />
        </div>
      </div>
    </div>
  )
}
